import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const { content } = useLanguage();
  const { faqData, ui } = content;

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {ui.faq.title}
          </h2>
          <p className="text-lg text-gray-400">
            {ui.faq.subtitle}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`faq-${faq.id}`}
              className="bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-xl overflow-hidden hover:border-blue-600/50 transition-colors duration-300"
            >
              <AccordionTrigger className="px-6 py-5 hover:no-underline text-left">
                <span className="text-lg font-semibold text-white pr-4">
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5">
                <p className="text-gray-400 leading-relaxed">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div className="mt-12 p-8 bg-gradient-to-r from-blue-950/30 to-gray-950/30 border border-blue-900/30 rounded-2xl text-center">
          <h3 className="text-xl font-bold text-white mb-2">
            {ui.faq.contactTitle}
          </h3>
          <p className="text-gray-400 mb-4">
            {ui.faq.contactText}
          </p>
          <a
            href="#contacto"
            className="inline-flex items-center text-blue-400 hover:text-blue-300 font-semibold transition-colors duration-200"
          >
            {ui.faq.contactCta}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
